import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthSession } from "../../components/AuthSessionProvider";

const useTokenExpiryHandler = (expiry: number) => {
  const navigate = useNavigate();
  const { logoutUser } = useAuthSession() as any;

  useEffect(() => {
    if (!expiry) return;

    const expiryDate = new Date(expiry * 1000);

    const interval = setInterval(() => {
      const currentTime = new Date();

      if (currentTime >= expiryDate) {
        clearInterval(interval);
        navigate("/auth/login");
        logoutUser();
        return;
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [expiry, navigate]);
};

export { useTokenExpiryHandler };
